function getUrlOrigin(url) {
  if (!url) return ''
  try {
    return new URL(url).origin
  } catch {
    return ''
  }
}

function getUrlEndpointPath(url) {
  if (!url) return ''
  try {
    const { pathname } = new URL(url)
    const parts = pathname.split('/').filter(Boolean)
    return '/' + parts.slice(2).join('/')
  } catch {
    return ''
  }
}

export function getErr998SentryExtra({ endpoint, method, clientId, uidSite, clientIp } = {}) {
  return {
    code: 'ERR_998',
    endpoint: getUrlEndpointPath(endpoint),
    method: method ?? '',
    site: clientId ?? '',
    ip: clientIp ?? '',
    apiHost: getUrlOrigin(endpoint),
    uidSite: uidSite ?? '',
  }
}
